import {
  MediapipePoseResults,
  PoseControlData,
} from "/@/shared/motion-menu-system/MenuTypes";

import {
  getWristsRotationQuaternion,
} from "./pose-and-hands-wrist-rotation.ts";

/**
 * Calculate pose control based on wrist-to-wrist orientation
 * Generates a quaternion representing the angle from left wrist to right wrist
 */

export const generatePoseControl = (): (
  poseResults?: MediapipePoseResults,
) => PoseControlData | undefined => {
  return (poseResults) => {
    if (!poseResults?.worldLandmarks?.[0]) {
      return undefined;
    }

    const poseWristAngle = getWristsRotationQuaternion(poseResults);

    return {
      ...poseWristAngle,
    };
  };
};
